import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { SUGGESTED_TAB, TARRIF_TAB } from 'context/reducers/tabs.type';
import { useAppContext } from 'hooks/useAppContext';
import { useFilteredData } from 'hooks/useFilteredData';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';
import React, { useEffect, useState } from 'react';
import * as Styled from './styled';

const TotalTruckers = () => {
  const {
    state: {
      truckers: { meta },
      refundableFare: { dataRefundableFare },
      tabs: { activeTab },
    },
  } = useAppContext();

  const { filteredDataSuggested, isFiltersApplied } = useFilteredData();
  const { hasConsumed, isPayPerUsePlan } = usePayPerUseExtraTruckers();
  const [total, setTotal] = useState<number>(null);

  const lockedTruckersAmount = meta?.truckersLimitsTotal?.locked;
  const hasLockedDrivers = !!lockedTruckersAmount && lockedTruckersAmount > 0;
  const showLockedDriversAmount = hasLockedDrivers && activeTab !== TARRIF_TAB && !isFiltersApplied;
  const showTotalDriversAmount = !!total || total === 0;

  const getLabelText = () => {
    if (isPayPerUsePlan && hasConsumed) {
      return lockedTruckersAmount === 1 ? 'desbloqueado' : 'desbloqueados';
    }

    return lockedTruckersAmount === 1 ? 'bloqueado' : 'bloqueados';
  };

  useEffect(() => {
    if (activeTab === SUGGESTED_TAB) {
      setTotal(isFiltersApplied ? filteredDataSuggested?.length : meta?.truckersLimitsTotal?.unlocked);
    }

    if (activeTab === TARRIF_TAB || 0) {
      setTotal(dataRefundableFare?.length);
    }
  }, [filteredDataSuggested, dataRefundableFare, activeTab, isFiltersApplied]);

  return (
    <Styled.TotalTruckersWrapper $hasLockedDrivers={showLockedDriversAmount}>
      {showTotalDriversAmount && (
        <FuelTypography size="caption" color="neutral-default" weight="bold">
          {total === 1 ? `${total} resultado` : `${total} resultados`}
        </FuelTypography>
      )}
      {showLockedDriversAmount && (
        <FuelFlex defaultProps={{ gap: 'km1', alignItems: 'center' }}>
          <Styled.IconWrapper>
            <FuelIcon
              name={isPayPerUsePlan && hasConsumed ? 'unlock' : 'lock'}
              size="micro"
              iconStyle="filled"
              data-testid="test-fuel-icon"
            />
          </Styled.IconWrapper>
          <FuelTypography size="caption" color="neutral-default" weight="bold">
            {lockedTruckersAmount} <Styled.BloquedTextWrapper>{getLabelText()}</Styled.BloquedTextWrapper>
          </FuelTypography>
        </FuelFlex>
      )}
    </Styled.TotalTruckersWrapper>
  );
};

export default TotalTruckers;
